import script from "./ChatView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatView.vue?vue&type=script&setup=true&lang=js"

import "./ChatView.vue?vue&type=style&index=0&id=36073a7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36073a7c"]])

export default __exports__